module.exports = __webpack_public_path__ + "static/media/icon-pocket-casts.8e2b8d81.svg";